module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/modules/_function-to-string.js
// module id = 1685
// module chunks = 0